import { render, staticRenderFns } from "./ECG_consult.vue?vue&type=template&id=2997465e"
import script from "./ECG_consult.vue?vue&type=script&lang=js"
export * from "./ECG_consult.vue?vue&type=script&lang=js"
import style0 from "./ECG_consult.vue?vue&type=style&index=0&id=2997465e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports